import { Box, Typography, useTheme } from "@mui/material";
import { blueGrey } from "@mui/material/colors";
import { addCommas } from "@persian-tools/persian-tools";
import { useNavigate } from "react-router-dom";
import useSWRMutation from "swr/mutation";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../hooks/useRedux";
import DolorGreen from "../../../../../../media/images/icons/dolor-green";
import InfoCircle from "../../../../../../media/images/icons/info-circle";
import {
  setDialogStatus,
  setDialogTitle,
  setOpenDialog,
} from "../../../../../../redux/features/dialogSlice";
import { setOwnerStock } from "../../../../../../redux/features/ownerSlice";
import { fetcherPost } from "../../../../../../services/fetcher";
import BottomSheetLayout from "../../../../../components/BottomSheetLayout";
import CustomButton from "../../../../../components/CustomButton";

interface Props {
  onDismiss: () => void;
  open: boolean;
  fare?: number;
  id?: string;
  paymentData: {
    bolNr?: string;
    senderWallet?: number;
  };
}

export default function PaymentBottomSheet(props: Props) {
  const { onDismiss, open, fare, id, paymentData } = props;

  const theme = useTheme();

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { stock } = useAppSelector((state) => state.owner);

  const { trigger: getOwnerWallet } = useSWRMutation(
    [`/Sender/GetWallet`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: async (data) => {
        dispatch(setOwnerStock(data));
      },
    }
  );

  const { trigger: setFarePay, isMutating: isSetFarePayMutating } =
    useSWRMutation(
      [`/Nobat/SetFarePay`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: () => {
          getOwnerWallet({});
          dispatch(setOpenDialog(true));
          dispatch(setDialogStatus("success"));
          dispatch(setDialogTitle("پرداخت کرایه با موفقیت انجام شد!"));
          setTimeout(() => {
            dispatch(setOpenDialog(false));
          }, 3000);
          onDismiss();
        },
      }
    );

  // const { data: paymentData, trigger: getPaymentData } = useSWRMutation(
  //   [`/Nobat/GetFarePay`, localStorage.getItem("access_token")],
  //   fetcherPost,
  //   {
  //     onSuccess: () => {
  //       // setBolsList(data.data);
  //       // setPageCounts(data.count);
  //     },
  //   }
  // );

  // useEffect(() => {
  //   if (open) {
  //     getPaymentData({
  //       id,
  //     });
  //   }
  // }, [open]);

  return (
    <BottomSheetLayout onDismiss={onDismiss} open={open}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          padding: "4px 4px 12px 4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            border: "1px solid",
            borderColor: blueGrey[100],
            padding: "8px",
            borderRadius: "8px",
          }}
        >
          <Box
            sx={{
              backgroundColor: theme.palette.primary[50],
              paddingY: "8px",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              justifyContent: "center",
            }}
          >
            <InfoCircle size={32} color={theme.palette.primary.main} />

            <Typography
              sx={{
                color: "primary.main",
                fontSize: "20px",
                fontWeight: "700",
              }}
            >
              پرداخت کرایه
            </Typography>
          </Box>
          {/* <Typography
            sx={{
              color: grey[700],
            }}
          >
            هزینه اعلام حضور برای شما مبلغ {addCommas("25000")} ریال می‌باشد، در
            صورت تایید، این هزینه از کیف پول شما کسر می‌گردد.
          </Typography> */}

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "700",
              }}
            >
              شماره بارنامه:
            </Typography>
            <Box
              sx={{
                display: "flex",
              }}
            >
              <Typography noWrap variant="body2">
                {paymentData?.bolNr || "---"}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              border: "1px solid",
              borderColor: theme.palette.secondary[600],
              backgroundColor: theme.palette.secondary[50],

              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              py: 1,
              borderRadius: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <DolorGreen color={theme.palette.secondary[600]} />
              <Typography
                sx={{
                  color: theme.palette.secondary[600],
                  fontSize: "16px",
                  fontWeight: "700",
                }}
              >
                کرایه:
              </Typography>
            </Box>
            <Typography
              sx={{
                color: theme.palette.secondary[600],
                fontSize: "16px",
                fontWeight: "700",
              }}
            >
              {addCommas(fare || "0")}
              ریال
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "16px",
              }}
            >
              موجودی کیف پول:
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <Typography
                sx={{
                  color: theme.palette.secondary.main,
                  fontSize: "18px",
                  fontWeight: "700",
                }}
              >
                {addCommas(paymentData?.senderWallet || "0")}
              </Typography>
              <Typography
                sx={{
                  color: theme.palette.secondary.main,
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                ریال
              </Typography>
            </Box>
          </Box>
        </Box>

        {typeof stock === "number" &&
        typeof fare === "number" &&
        stock < fare ? (
          <>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "700",
                textAlign: "center",
              }}
            >
              موجودی کیف پول شما ناکافی است!
            </Typography>
            <CustomButton
              onClick={() => navigate("../wallet")}
              flex={1}
              flexDirection="row"
              title="شارژ کیف پول"
              justifyContent="center"
              bgColor="primary.main"
              fSize="16px"
              px="10px"
              py="10px"
              borderRadius="10px"
              // icon1={<CheckCircle size={32} />}
            />
          </>
        ) : (
          <>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "700",
                textAlign: "center",
              }}
            >
              آیا مایل به کسر هزینه و پرداخت کرایه از کیف پول هستید؟
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <CustomButton
                loading={isSetFarePayMutating}
                onClick={() => {
                  setFarePay({
                    id,
                  });
                }}
                flex={1}
                flexDirection="row"
                title="پرداخت کرایه"
                justifyContent="center"
                bgColor="primary.main"
                fSize="16px"
                px="10px"
                py="10px"
                borderRadius="10px"
                // icon1={<CheckCircle size={32} />}
              />
              <CustomButton
                // loading={loading}
                onClick={() => onDismiss()}
                flexDirection="row"
                title="انصراف"
                borderColor="primary.main"
                textColor="primary.main"
                justifyContent="center"
                bgColor="#fff"
                fSize="16px"
                px="10px"
                py="10px"
                borderRadius="10px"
                // icon1={<CheckCircle size={32} />}
              />
            </Box>
          </>
        )}
      </Box>
    </BottomSheetLayout>
  );
}
